module.exports = __webpack_public_path__ + "img/France.f1ab9b8b.png";